module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-47d0afa37a6ee92c08840516f208b154.png";